exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-upload-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 15px;\n  padding: 20px; }\n\n.file-info {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n  color: #4caf50; }\n\n.loading-info {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n  color: #2196f3; }\n\n.invisible {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/DocumentsModule/DocumentPaymentsUploadDialogComponent/document-payments-upload.dialog.component.scss
// module id = ../../../../../src/DocumentsModule/DocumentPaymentsUploadDialogComponent/document-payments-upload.dialog.component.scss
// module chunks = main